/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Silent_Brisk_Otter_GlowInputs */

const en_silent_brisk_otter_glow = /** @type {(inputs: Silent_Brisk_Otter_GlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stars`)
};

const de_silent_brisk_otter_glow = /** @type {(inputs: Silent_Brisk_Otter_GlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sterne`)
};

/**
* | output |
* | --- |
* | "Stars" |
*
* @param {Silent_Brisk_Otter_GlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const silent_brisk_otter_glow = /** @type {((inputs?: Silent_Brisk_Otter_GlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Silent_Brisk_Otter_GlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_silent_brisk_otter_glow(inputs)
	return de_silent_brisk_otter_glow(inputs)
});